import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const ImpersonatePage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { logout } = useAuth();

  useEffect(() => {
    const processImpersonation = async () => {
      try {
        const token = searchParams.get('token');
        
        if (!token) {
          setError('Token de impersonificação não fornecido');
          setLoading(false);
          return;
        }

        // Fazer logout do admin primeiro
        logout();

        // Fazer login com token de impersonificação
        const response = await api.post('/auth/login-impersonado', { token });
        
        if (response.data.token) {
          // Configurar token de impersonificação
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('impersonacao', 'true');
          api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
          
          // Redirecionar para a home como o usuário impersonado
          window.location.href = '/';
        }
        
      } catch (error) {
        console.error('Erro na impersonificação:', error);
        setError('Erro ao processar impersonificação: ' + (error.response?.data?.erro || error.message));
        setLoading(false);
      }
    };

    processImpersonation();
  }, [searchParams, logout]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-500 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-white mb-2">Processando impersonificação...</h2>
          <p className="text-slate-300">Entrando na conta do usuário...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-white mb-2">Erro na Impersonificação</h2>
          <p className="text-slate-300 mb-4">{error}</p>
          <button 
            onClick={() => window.close()}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors"
          >
            Fechar
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default ImpersonatePage; 